import React from 'react';
import { IoMdPerson, IoMdTime } from 'react-icons/io';
import { FiArrowRight } from 'react-icons/fi';
import { useLanguage } from '../../context/LanguageContext';
import { getLocalizedCaseDisplay } from '../../data/caseProfiles';
import './PatientHeader.css';

const PatientHeader = ({
  selectedCase,
  patientImage,
  onImageClick,
  timer,
  sessionActive,
  currentPhase,
  phaseTimeRemaining,
  formatPhaseTime,
  currentPhaseIndex,
  totalPhases,
  onNextPhase
}) => {
  const { language, t, phaseName } = useLanguage();
  if (!selectedCase) return null;
  const displayCase = getLocalizedCaseDisplay(selectedCase, language);

  return (
    <div className="patient-header">
      <div className="patient-profile">
        <div className="profile-avatar" onClick={onImageClick}>
          {patientImage ? (
            <img
              src={patientImage}
              alt={displayCase.name}
              className="avatar-image"
            />
          ) : (
            <div className="avatar-fallback">
              <IoMdPerson size={28} />
            </div>
          )}
        </div>
        <div className="profile-info">
          <h2>{displayCase.name}</h2>
          <div className="profile-meta">
            <span className="meta-item">
              <IoMdPerson size={16} />
              {displayCase.age} {t('years')}
            </span>
            <span className="meta-item">
              <IoMdTime size={16} />
              {t('caseId')}: {displayCase.id}
            </span>
          </div>

          {/* Timer Display - Horizontal Layout */}
          {sessionActive && timer && timer.isActive && (
            <div className="timer-section">
              <div className="timer-container-horizontal">
                <div className="phase-badge-inline">
                  <span className="phase-name-inline">{phaseName(currentPhase)}</span>
                </div>
                <div className="timer-box-inline">
                  <span className="timer-label-inline">{t('session')}</span>
                  <div className={`timer-value-inline ${timer.isWarning ? 'warning' : ''}`}>
                    {timer.formattedTime}
                  </div>
                </div>
                <div className="timer-box-inline">
                  <span className="timer-label-inline">{t('phase')}</span>
                  <div className={`timer-value-inline phase-timer ${phaseTimeRemaining <= 60000 ? 'warning' : ''}`}>
                    {formatPhaseTime(phaseTimeRemaining)}
                  </div>
                </div>
                {currentPhaseIndex !== -1 && currentPhaseIndex < totalPhases - 1 && (
                  <button
                    className="next-phase-btn-inline"
                    onClick={onNextPhase}
                    title={t('next')}
                  >
                    <FiArrowRight size={14} />
                    <span>{t('next')}</span>
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PatientHeader;
